<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>项目名称</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <el-card class="box-card">
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入产品名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.code" @keyup.enter.native="clicksearch" placeholder="请输入产品编码"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.classification" placeholder="请选择" class="select">
                <el-option label="请选择分类" value=""></el-option>
                <el-option label="产品" value="产品"></el-option>
                <el-option label="辅助产品" value="辅助产品"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
              <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
              <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
              注意：此处是覆盖导入
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->

          <!-- 数据列表 start -->
          <el-table v-loading="loading" :data="dataList" ref="dataList" :cell-style="{padding: '0'}" border height="440">
            <el-table-column prop="Name" label="产品名称" min-width="25%"></el-table-column>
            <el-table-column label="产品编码" min-width="25%">
              <template slot-scope="scope">
                <span v-if="scope.row.IsRepeat === 1" style="color: #05bb74;">{{ scope.row.Code }}</span>
                <span v-if="scope.row.IsRepeat === 2" style="color: #e95d4e;">{{ scope.row.Code }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Code" label="产品编码" min-width="25%"></el-table-column>
            <el-table-column prop="Specifications" label="规格型号" min-width="25%"></el-table-column>
            <el-table-column prop="Classification" label="分类" min-width="10%"></el-table-column>
            <el-table-column prop="Highestprice" label="上限价格" min-width="15%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyErp6ProjectName',
  data () {
    return {
      loading: false,
      activeName: 'first',
      // 查询
      keywords: {
        name: '',
        code: '',
        classification: ''
      },
      dataList: []
    }
  },
  mounted () {
    this.apiGetErp6ProjectNameList()
  },
  methods: {
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6ProjectName(url)
    },
    clicksearch () {
      this.apiGetErp6ProjectNameList()
    },
    clickexcel () {
      this.apiExcelErp6ProjectName()
    },
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        code: that.keywords.code,
        classification: that.keywords.classification
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExcelImportErp6ProjectName: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6ProjectName, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6ProjectNameList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6ProjectName: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        code: that.keywords.code,
        classification: that.keywords.classification
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6ProjectName, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
